import { App } from 'vue';
import { ApiConfiguration, ApiService } from '../../../modules/api';

export class ApiPlugin {

    constructor(private configuration: ApiConfiguration) {
    }

    public install(app: App): void {
        app.config.globalProperties[ApiService.identifier] = ApiService.getInstance(this.configuration);
    }    
    
}
